/* eslint-disable react-hooks/exhaustive-deps */
import { motion } from 'framer-motion/dist/framer-motion';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import logo from '../../assets/img/saw-logo.png';
import { RootState } from '../../store/reducers';
import { checkUserInterestedInvestor, checkUserRoleAccessDashboard, getRegistrarDetailFromLocalStorage, getUserImageURL, isUserLoggedIn, isUserRole } from '../../utils/handler';
// import i18n from '../../i18n';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { APPRAISAL_DETAIL } from '../../store/actions/types';

interface naveType {
  path: string;
  name: string;
  isPrivate?: boolean;
  hideMenu?: boolean;
  onlyDirectUser?: boolean;
}

const variants = {
  open: { opacity: 1, x: 0 },
  closed: { opacity: 0, x: '-100%' },
};

export const RewampedHeader: React.FC = (): JSX.Element => {
  let registrarObj = getRegistrarDetailFromLocalStorage();
  let landingRouter = '/';
  if (registrarObj) {
    landingRouter = '/';
  }

  let navLink = [
    // { path: '/login', name: 'Login' },
    { path: landingRouter, name: 'Buy' },
    { path: '/sell', name: 'Sell', onlyDirectUser: true },
    { path: '/appraisal', name: 'Appraisals', onlyDirectUser: true },
    // { path: '/dashboard', name: 'Dashboard', isPrivate: true, hideMenu: true },
  ];
  let moreMenu = [
    { path: '/about', name: 'About' },
    { path: '/Faq', name: 'FAQs', onlyDirectUser: true },
  ];
  const [navLinks, setNavLinks] = useState(navLink);
  const { myProfile, registrarDetails } = useSelector((state: RootState) => state.userReducer);
  let history = useHistory();
  const [showMenu, setShowMenu] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const isLarge = useMediaQuery('(min-width: 801px)');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getCurrentPath = (pathName: string) => {
    return (pathName === '/') ? landingRouter : pathName;
  };

  useEffect(() => {
    setCurrentPath(getCurrentPath(history.location.pathname));
    history.listen(() => {
      setCurrentPath(getCurrentPath(history.location.pathname));
    });
  }, [history]);

  // useEffect(() => {
  //   if (_.isEmpty(myProfile)) {
  //     setNavLinks([{ path: '/login', name: 'Login' }, ...navLink]);
  //   } else if (history.location.pathname === "/") {
  //     setNavLinks([{ path: '/login', name: 'Login' }, ...navLink]);
  //   } else {
  //     let navList = _.filter(navLinks, (obj) => obj.name !== 'Login');
  //     navList = _.map(navList, (obj) => {
  //       if (obj.name === 'Dashboard') obj.hideMenu = checkUserInterestedInvestor() || checkUserRoleAccessDashboard();
  //       return obj;
  //     });
  //     setNavLinks(navList);
  //   }
  // }, [myProfile]);

  const handleRouter = (path: string) => {
    // const leadDetails = myLeadList[0] || {}

    if (isUserRole() && path === '/dashboard') {
      history.push(path);

      // if (isEmpty(leadDetails)) {
      //     getMyLeads().then(response => {
      //         if (response && response.length === 0) {
      //             history.push("/")
      //         } else {
      //             history.push(path)
      //         }
      //     })
      // } else {
      //     history.push(path)
      // }
    } else if (path === '/login') {
      // dispatch({ type: SHOW_LOGIN_WINDOW, payload: true });
      history.push(path);
    } else if (path === '/appraisal') {
      dispatch({ type: APPRAISAL_DETAIL, payload: {} });
      history.push(path);
    } else {
      history.push(path);
    }
  };
  const showHeader = (path: string) => {
    if (
      _.find(navLinks, (navObj) => {
        return navObj.path.toLowerCase() === path;
      }) ||
      path.toLocaleLowerCase() === '/profile'
    )
      return true;
    return true;
  };
  const isRegistrarUser = () => {
    if (!isUserLoggedIn() && registrarDetails && !_.isEmpty(registrarDetails)) {
      return true;
    }
    return false;
  };
  const checkIsOnlyDirectUserMenu = (nav: naveType) => {
    if (nav.onlyDirectUser && !isUserLoggedIn() && isRegistrarUser()) {
      return true;
    }
    return false;
  };
  const checkPrivateNav = (nav: naveType, index: number, className: string = '') => {
    // if ((nav.isPrivate && !isUserLoggedIn()) || nav.hideMenu) {
    //   return null;
    // }
    // if (checkIsOnlyDirectUserMenu(nav)) {
    //   return null;
    // }
    if (nav.name === "About") {
      return (
        <li key={index} className={'nav-item'} onClick={() => { window.location.href = 'https://saw.com/about' }}>
          <span onClick={() => setShowMenu(false)} className={'nav-link text-nowrap f-bold ' + className + (nav.path.toLowerCase() === currentPath.toLowerCase() ? ' nav-active' : '')}>
            {t(nav.name)}
          </span>
        </li>
      );
    }
    if (nav.name === "FAQs") {
      return (
        <li key={index} className={'nav-item'} onClick={() => { window.location.href = 'https://saw.com/faq#buy' }}>
          <span onClick={() => setShowMenu(false)} className={'nav-link text-nowrap f-bold ' + className + (nav.path.toLowerCase() === currentPath.toLowerCase() ? ' nav-active' : '')}>
            {t(nav.name)}
          </span>
        </li>
      );
    }
    if (nav.name === "Sell") {
      return (
        <li key={index} className={'nav-item'} onClick={() => { window.location.href = 'https://saw.com/sell' }}>
          <span onClick={() => setShowMenu(false)} className={'nav-link text-nowrap f-bold ' + className + (nav.path.toLowerCase() === currentPath.toLowerCase() ? ' nav-active' : '')}>
            {t(nav.name)}
          </span>
        </li>
      );
    }
    if (nav.name === "Appraisals") {
      return (
        <li key={index} className={'nav-item'} onClick={() => { window.location.href = 'https://saw.com/appraisal' }}>
          <span onClick={() => setShowMenu(false)} className={'nav-link text-nowrap f-bold ' + className + (nav.path.toLowerCase() === currentPath.toLowerCase() ? ' nav-active' : '')}>
            {t(nav.name)}
          </span>
        </li>
      );
    }
    return (
      <li key={index} className={'nav-item'} onClick={() => handleRouter(nav.path)}>
        <span onClick={() => setShowMenu(false)} className={'nav-link text-nowrap f-bold ' + className + (nav.path.toLowerCase() === currentPath.toLowerCase() ? ' nav-active' : '')}>
          {t(nav.name)}
        </span>
      </li>
    );
  };
  const getMoreMenu = () => {
    let moreMenuItems: naveType[] = [];
    moreMenu.forEach((naveItem) => {
      if (!checkIsOnlyDirectUserMenu(naveItem)) {
        moreMenuItems.push(naveItem);
      }
    });
    return moreMenuItems;
  };
  return (
    <>
      {!showHeader(history.location.pathname.toLowerCase()) ? (
        <header className=" ">
          <div className="container header-content ">
            <div className="header-left d-flex">
              <img alt="logo-png" src={logo} className="header-logo  c-pointer" onClick={() => handleRouter(landingRouter)} />
            </div>
          </div></header>) : null}
      {showHeader(history.location.pathname.toLowerCase()) ? (
        <div className="rewamped-header font-dm-sans color-text-grey">
          <div className="rewamp-container">
            <img alt="logo-png" src={logo} className="header-logo  c-pointer" onClick={() => handleRouter(landingRouter)} />
            <motion.nav initial="closed" transition={{ duration: 0.3 }} animate={!isLarge && showMenu ? 'open' : 'closed'} exit="closed" variants={variants} className={'nav-open navbar-expand-lg'}>
              <ul className="navbar-nav  menu-bar">{[...navLinks, ...moreMenu].map((nav: naveType, index: number) => checkPrivateNav(nav, index))}</ul>
            </motion.nav>
            <nav className={' navbar-expand-lg navbar-custom '}>
              <ul className="navbar-nav ">
                {navLinks.map((nav: naveType, index: number) => checkPrivateNav(nav, index))}
                {getMoreMenu().length ? (
                  <li className="nav-item dropdown">
                    <div className="nav-link dropdown-toggle" data-mdb-toggle="dropdown" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                      More
                    </div>
                    <ul className={'dropdown-menu nav-drop-down '} id="nav-menu-item">
                      {getMoreMenu().map((nav: naveType, index: number) => checkPrivateNav(nav, index, 'dropdown-item'))}
                    </ul>
                  </li>
                ) : null}
              </ul>
            </nav>

          </div>
          <div id="userbox" className="userbox">
            {isUserLoggedIn() && history.location.pathname !== "/" && <Avatar onClick={() => handleRouter('/profile')} className="profile-picture" size={'35'} textSizeRatio={3} round={true} name={myProfile?.name} src={getUserImageURL(myProfile?.image)} />}
            <div className="menu-bar" onClick={() => setShowMenu(!showMenu)}>
              <i className={'fas fs-30 theme-color' + (showMenu ? ' fa-times' : ' fa-bars ')}></i>
            </div>
          </div>
        </div>

      ) : null}
    </>);
};

export default RewampedHeader;

